import React, {useEffect, useState} from 'react'
import {HEX} from "../types/colors";



export default function GetColor({hexinput, handleHexinput}:{hexinput:HEX, handleHexinput:(input:HEX)=>void}){
    const [colorinput, setColorinput] = useState< HEX >(hexinput)

    // useEffect(() => {
    //     sendDataBack()
    // }, [colorinput]);

    let sendDataBack = ()=>{
        handleHexinput(colorinput)
    }

    let handleColorinput = (color:React.ChangeEvent<HTMLInputElement> ) => {
        console.log(color.target.value)
        setColorinput(color.target.value.toUpperCase() as HEX)
    }

    return (<>
        <span>Click away to confirm color</span><br/>
        <input type={"color"} onChange={handleColorinput} value={colorinput} onBlur={sendDataBack}/>

    </>)
}
